import { withZod } from '@remix-validated-form/with-zod'
import { z } from 'zod'

export const userInviteValidator = withZod(
  z
    .object({
      name: z.string().min(1, { message: `Name is required` }),
      email: z.string().trim().min(1, { message: `Email is required` }).email(`Must be a valid email`),
    })
    .passthrough(),
) as any
